import React from 'react';

import { type THeadingBlock } from '@wp-block-builder/blocks/Heading';
import { generateRandomBlockId } from '@wp-block-builder/package';

import BlockTypeIcon from '../../../../../blocks/helpers/BlockTypeIcon';

import defineBlockButton from './helpers/defineBlockButton';

const getDefaultProps = (style: { padding: string }): THeadingBlock => ({
  id: generateRandomBlockId(),
  type: 'Heading',
  style: {
    fontFamily: 'inherit',
    fontWeight: 'bold',
    textAlign: 'left',
    ...style,
  },
  props: {
    level: 'h2',
    text: 'Hello {{firstName | default: "friend" }}',
  },
  sectionProps: {},
});

export default defineBlockButton<THeadingBlock>({
  label: 'Heading',
  icon: <BlockTypeIcon type="Heading" />,
  defaultBlock: () => getDefaultProps({ padding: '16px 24px 16px 24px' }),
  defaultContainerBlock: () => getDefaultProps({ padding: '16px 0px 16px 0px' }),
  defaultColumnBlock: () => getDefaultProps({ padding: '0px 0px 0px 0px' }),
});
